/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */
import { removeTimeZoneFromDate, toDateStringOnly } from 'utils/dateUtil';
import { configAppInstance } from '../../../configureApp';

function mapToParentSection(data) {
  const thirdPartyDob = toDateStringOnly(removeTimeZoneFromDate(data.thirdPartyDateOfBirth));
  return {
    proxyTitle: data.thirdPartyTitle,
    proxyFirstName: data.thirdPartyFirstName,
    proxySurname: data.thirdPartySurName,
    proxyDOB: thirdPartyDob,
    proxyEmail: data.thirdPartyEmail,
    proxyMobile: data.thirdPartyMobilePhone,
    proxyPhone: data.thirdPartyHomePhone,
    proxyAddressLine1: data.thirdPartyAddressLine1,
    proxyAddressLine2: data.thirdPartyAddressLine2,
    proxyAddressState: data.thirdPartyState,
    proxyAddressCode: data.thirdPartyPostal,
    ProxyAddressCity: data.thirdPartyCity,
    ProxyCountry: data.thirdPartyCountry,
    clientType: configAppInstance.client,
    proxyRelationship: data.thirdPartyRelationShip,
    proxyEnabled: data.givePermission.toString(),
    contactEmail: (!data.preferredContactEmailForClaim) ? data.email : data.preferredContactEmailForClaim,
    contactMobile: (!data.preferredContactNumberForClaim) ? data.mobile : data.preferredContactNumberForClaim,
    preferredContactName: data.preferredContactForClaim,
  };
}

function mapToQuestionnaire(data, claimCode) {
  return [
    {
      question: 'section1.givePermission',
      answer: data.givePermission,
      claimTypeCode: claimCode,
    },
  ];
}

function mapToExpenses() {
  return [];
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepClaimSummaryDataMapper.js